import { render, staticRenderFns } from "./Circle.vue?vue&type=template&id=0497152a&scoped=true"
import script from "./Circle.vue?vue&type=script&lang=js"
export * from "./Circle.vue?vue&type=script&lang=js"
import style0 from "./Circle.vue?vue&type=style&index=0&id=0497152a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0497152a",
  null
  
)

export default component.exports